import "core-js/modules/es.error.cause.js";
import topTitle from '@/components/title';
import { editCertificate, workersZip, streamInfo } from './../../../organization/staffManage/request';
import { uploadFile } from './../../../customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
import { getBase64 } from '@/utils/validate';
import { downloadFileFun } from '@/utils/public';
const Base64 = require('js-base64').Base64;
export default {
  props: ['id', 'infoObj', 'type'],
  components: {
    topTitle
  },
  data() {
    return {
      form: {},
      action: uploadFile,
      previewVisible: false,
      previewImage: '',
      disabled: false,
      idCardFrontObj: [],
      idCardBackObj: [],
      diplomaObj: [],
      bankCardObj: [],
      laborContractObj: [],
      qualificationObj: [],
      loading: false
    };
  },
  computed: {
    dataRule() {
      return {
        idCardFront: [{
          required: true,
          type: 'array',
          validator: this.validateImg,
          trigger: 'blur'
        }],
        idCardBack: [{
          required: true,
          type: 'array',
          validator: this.validateIdCardBackImg,
          trigger: 'blur'
        }],
        diploma: [{
          required: true,
          type: 'array',
          validator: this.validateDiploma,
          trigger: 'blur'
        }],
        bankCard: [{
          required: true,
          type: 'array',
          validator: this.validateBankCard,
          trigger: 'blur'
        }]
      };
    }
  },
  created() {
    setTimeout(() => {
      this.disabled = this.type == 1 ? true : false;
      if (this.infoObj.idCardFront.url) {
        this.idCardFrontObj = [{
          url2: this.getImgUrlFun(this.infoObj.idCardFront.url),
          uid: 1,
          name: this.infoObj.idCardFront.name,
          status: 'done',
          type: this.infoObj.idCardFront.format,
          url: this.infoObj.idCardFront.url
        }];
      }
      if (this.infoObj.idCardBack.url) {
        this.idCardBackObj = [{
          url2: this.getImgUrlFun(this.infoObj.idCardBack.url),
          uid: 1,
          name: this.infoObj.idCardBack.name,
          status: 'done',
          type: this.infoObj.idCardBack.format,
          url: this.infoObj.idCardBack.url
        }];
      }
      if (this.infoObj.diploma.url) {
        this.diplomaObj = [{
          url2: this.getImgUrlFun(this.infoObj.diploma.url),
          uid: 1,
          name: this.infoObj.diploma.name,
          status: 'done',
          type: this.infoObj.diploma.format,
          url: this.infoObj.diploma.url
        }];
      }
      if (this.infoObj.bankCard.url) {
        this.bankCardObj = [{
          url2: this.getImgUrlFun(this.infoObj.bankCard.url),
          uid: 1,
          name: this.infoObj.bankCard.name,
          status: 'done',
          type: this.infoObj.bankCard.format,
          url: this.infoObj.bankCard.url
        }];
      }
      if (this.infoObj.laborContract.url) {
        this.laborContractObj = [{
          url2: this.getImgUrlFun(this.infoObj.laborContract.url),
          uid: 1,
          name: this.infoObj.laborContract.name,
          status: 'done',
          type: this.infoObj.laborContract.format,
          url: this.infoObj.laborContract.url
        }];
      }
    }, 400);
  },
  methods: {
    validateImg(rule, value, callback) {
      if (this.idCardFrontObj.length == 0) {
        callback(new Error(this.$t('请上传') + this.$t('身份证正面')));
      } else {
        callback();
      }
    },
    validateIdCardBackImg(rule, value, callback) {
      if (this.idCardBackObj.length == 0) {
        callback(new Error(this.$t('请上传') + this.$t('身份证反面')));
      } else {
        callback();
      }
    },
    validateDiploma(rule, value, callback) {
      if (this.diplomaObj.length == 0) {
        callback(new Error(this.$t('请上传') + this.$t('学历照片')));
      } else {
        callback();
      }
    },
    validateBankCard(rule, value, callback) {
      if (this.bankCardObj.length == 0) {
        callback(new Error(this.$t('请上传') + this.$t('银行卡正面')));
      } else {
        callback();
      }
    },
    getImgUrlFun(url) {
      let url2 = url.split('/');
      let imgUrlBox = url2[url2.length - 1];
      let img = imgUrlBox.split('.')[0];
      let url3 = Base64.decode(Base64.decode(img)) + '.' + imgUrlBox.split('.')[1];
      return url.replace(imgUrlBox, url3);
    },
    async handlePreview(file) {
      if (file.type == 'application/pdf' || file.type == 'pdf') {
        console.log(file.preview);
        if (file.response) {
          if (process.env.NODE_ENV === 'production') {
            window.open(cryptoDecrypt(file.response.data).fileTempUrl);
          } else {
            window.open(file.response.data.fileTempUrl);
          }
        } else {
          window.open(file.url);
        }
      } else {
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file.originFileObj);
        }
        this.previewImage = file.url || file.preview;
        this.previewVisible = true;
      }
    },
    onSubmit() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          this.loading = true;
          this.form.customerId = this.infoObj.customerId, this.form.companyWorkerId = this.id;
          this.form.idCardFront = this.getUrlFun(this.idCardFrontObj);
          this.form.idCardBack = this.getUrlFun(this.idCardBackObj);
          this.form.diploma = this.getUrlFun(this.diplomaObj);
          this.form.bankCard = this.getUrlFun(this.bankCardObj);
          if (this.laborContractObj.length != 0) {
            this.form.laborContract = this.getUrlFun(this.laborContractObj);
          }
          editCertificate(this.form).then(res => {
            this.loading = false;
            if (res.code == 200) {
              this.$message.success(this.$t('操作成功'));
              this.$emit('back');
            } else {
              this.$message.error(this.$t(res.message));
            }
          });
        }
      });
    },
    getUrlFun(arr) {
      let url = '';
      if (arr[0].status == 'done' && arr[0].response && arr[0].response.code == 200) {
        if (process.env.NODE_ENV === 'production') {
          url = cryptoDecrypt(arr[0].response.data).fileTempUrl;
        } else {
          url = arr[0].response.data.fileTempUrl;
        }
      } else {
        console.log(arr[0].url2, 444);
        url = arr[0].url2;
      }
      return url;
    },
    getImgChenckFun(info, name) {
      if (info.file.status === 'done') {
        if (info.file.response.code != 200) {
          this.$message.error(info.file.response.message);
          this[name][this[name].length - 1].status = 'error';
        }
      }
      this[name] = info.fileList;
    },
    handleChange(info) {
      this.getImgChenckFun(info, 'idCardFrontObj');
    },
    idCardBackChange(info) {
      this.getImgChenckFun(info, 'idCardBackObj');
    },
    diplomaChange(info) {
      this.getImgChenckFun(info, 'diplomaObj');
    },
    bankCardChange(info) {
      this.getImgChenckFun(info, 'bankCardObj');
    },
    laborContractChange(info) {
      this.getImgChenckFun(info, 'laborContractObj');
    },
    qualificationChange(info) {
      this.getImgChenckFun(info, 'qualificationObj');
    },
    downloadFun() {
      if (this.bankCardObj.length == 0 && this.idCardFrontObj.length == 0 && this.idCardBackObj.length == 0 && this.laborContractObj.length == 0 && this.diplomaObj.length == 0) {
        this.$message.error(this.$t('暂无可下载的证件资料'));
        return false;
      }
      workersZip({
        companyWorkerId: this.id,
        customerId: this.$route.params.customerId
      }).then(res => {
        let nowDate = new Date();
        let time = nowDate.getFullYear() + '-' + Number(Number(nowDate.getMonth()) + 1) + '-' + nowDate.getDate();
        downloadFileFun(res, 'application/zip', this.infoObj.name + -this.$t('证件资料') + time + '.zip');
      });
    },
    downloadFun2(obj) {
      const type2 = obj.format == 'pdf' ? 'application/pdf' : obj.format == 'png' ? 'image/png' : obj.format == 'jpg' ? 'image/jpg' : obj.format == 'jpeg' ? 'image/jpeg' : obj.format == 'gif' ? 'image/gif' : obj.format == 'jfif' ? 'image/jfif' : '';
      streamInfo({
        url: obj.url2
      }).then(res => {
        console.log(res);
        // let a = document.createElement('a');
        // let blob = new Blob([res], {type: type2});
        // let objectUrl = URL.createObjectURL(blob);
        // a.setAttribute('href',objectUrl);
        // let nowDate = new Date();
        // let time=nowDate.getFullYear()+'-'+Number(Number(nowDate.getMonth()) + 1)+'-'+nowDate.getDate();
        // a.setAttribute('download',obj.name);
        // a.click();
        downloadFileFun(res, type2, obj.name);
      });
    }
  }
};